import httpClient from '../utils/httpClient';

export const getProductCategory = async () => {
    const response = await httpClient.post('/ProductCategory/GetProductCategory');
    return response.data;
};

